/**
 * Auto-generated icon type definitions
 *
 * DO NOT EDIT MANUALLY - This file is generated by scripts/generate-types.ts
 * Run: pnpm run generate:types
 */

/**
 * Union type of all available icon names (PascalCase)
 *
 * Use this type for type-safe icon references:
 *
 * @example
 * ```tsx
 * import type { IconName } from 'motionicon';
 *
 * function IconButton({ icon }: { icon: IconName }) {
 *   // Type-safe icon name with autocomplete
 * }
 * ```
 */
export type IconName =
  | 'Accessibility'
  | 'Activity'
  | 'Airplay'
  | 'AlertCircle'
  | 'AlertOctagon'
  | 'AlertTriangle'
  | 'Anchor'
  | 'Apple'
  | 'Archive'
  | 'AreaChart'
  | 'ArrowDown'
  | 'ArrowDownLeft'
  | 'ArrowDownRight'
  | 'ArrowLeft'
  | 'ArrowRight'
  | 'ArrowUp'
  | 'ArrowUpLeft'
  | 'ArrowUpRight'
  | 'AtSign'
  | 'Award'
  | 'Baby'
  | 'Backpack'
  | 'BadgeCheck'
  | 'Ban'
  | 'Banana'
  | 'Bandage'
  | 'BarChart'
  | 'BarChart2'
  | 'Barcode'
  | 'Battery'
  | 'BatteryCharging'
  | 'BatteryLow'
  | 'Beer'
  | 'Bell'
  | 'Bike'
  | 'Bluetooth'
  | 'Bone'
  | 'Book'
  | 'BookMarked'
  | 'BookOpen'
  | 'Bookmark'
  | 'Brain'
  | 'Brush'
  | 'Building'
  | 'Building2'
  | 'Bus'
  | 'Calculator'
  | 'Calendar'
  | 'Camera'
  | 'Car'
  | 'CarFront'
  | 'Carrot'
  | 'Cast'
  | 'Castle'
  | 'Check'
  | 'CheckCircle'
  | 'ChefHat'
  | 'Cherry'
  | 'ChevronDown'
  | 'ChevronUp'
  | 'ChevronsDown'
  | 'ChevronsLeft'
  | 'ChevronsRight'
  | 'ChevronsUp'
  | 'Church'
  | 'Circle'
  | 'Clipboard'
  | 'ClipboardCheck'
  | 'ClipboardCopy'
  | 'ClipboardList'
  | 'Clock'
  | 'Cloud'
  | 'CloudDrizzle'
  | 'CloudLightning'
  | 'CloudRain'
  | 'CloudSnow'
  | 'CloudSun'
  | 'Code'
  | 'Code2'
  | 'Coffee'
  | 'Columns'
  | 'Command'
  | 'Compass'
  | 'Contact'
  | 'Contact2'
  | 'Cookie'
  | 'Copy'
  | 'CornerDownLeft'
  | 'CornerDownRight'
  | 'CornerUpLeft'
  | 'CornerUpRight'
  | 'Cpu'
  | 'CreditCard'
  | 'Crosshair'
  | 'Crown'
  | 'Cup'
  | 'Database'
  | 'Dice1'
  | 'Dice2'
  | 'Dice3'
  | 'Dice4'
  | 'Dice5'
  | 'Dice6'
  | 'Dna'
  | 'DollarSign'
  | 'Download'
  | 'Droplet'
  | 'Dumbbell'
  | 'Ear'
  | 'Edit'
  | 'Eraser'
  | 'Eye'
  | 'Eye2'
  | 'EyeOff'
  | 'Factory'
  | 'FastForward'
  | 'File'
  | 'FileCheck'
  | 'FileMinus'
  | 'FilePlus'
  | 'FileText'
  | 'FileX'
  | 'Files'
  | 'Film'
  | 'Filter'
  | 'Fingerprint'
  | 'Flame'
  | 'Folder'
  | 'FolderMinus'
  | 'FolderOpen'
  | 'FolderPlus'
  | 'Footprints'
  | 'Frown'
  | 'Fuel'
  | 'Gamepad2'
  | 'Gauge'
  | 'Gift'
  | 'Glasses'
  | 'Globe'
  | 'GraduationCap'
  | 'Grape'
  | 'Grid'
  | 'Hammer'
  | 'Hand'
  | 'HardDrive'
  | 'Hash'
  | 'Headphones'
  | 'Heart'
  | 'HeartPulse'
  | 'HelpCircle'
  | 'Highlighter'
  | 'Home'
  | 'Hospital'
  | 'IceCream'
  | 'Inbox'
  | 'Info'
  | 'Joystick'
  | 'Kanban'
  | 'Key'
  | 'KeyRound'
  | 'Keyboard'
  | 'Lamp'
  | 'LampDesk'
  | 'Landmark'
  | 'Laptop'
  | 'Layout'
  | 'LayoutGrid'
  | 'LayoutList'
  | 'Leaf'
  | 'Library'
  | 'Lightbulb'
  | 'LightbulbOff'
  | 'LineChart'
  | 'Link'
  | 'List'
  | 'Loader'
  | 'Lock'
  | 'LockOpen'
  | 'Mail'
  | 'Map'
  | 'MapPin'
  | 'Martini'
  | 'Maximize'
  | 'Maximize2'
  | 'Medal'
  | 'Meh'
  | 'Menu'
  | 'MessageCircle'
  | 'MessageSquare'
  | 'Mic'
  | 'MicOff'
  | 'Microscope'
  | 'Milestone'
  | 'Minimize'
  | 'Minimize2'
  | 'Minus'
  | 'Monitor'
  | 'Moon'
  | 'MoreHorizontal'
  | 'Mountain'
  | 'MountainSnow'
  | 'Mouse'
  | 'MoveHorizontal'
  | 'Music'
  | 'Navigation'
  | 'Navigation2'
  | 'Notebook'
  | 'NotebookPen'
  | 'Package'
  | 'Palette'
  | 'PanelLeft'
  | 'PanelRight'
  | 'Paperclip'
  | 'Parking'
  | 'Pause'
  | 'Pen'
  | 'PenTool'
  | 'Pencil'
  | 'Percent'
  | 'Phone'
  | 'PhoneCall'
  | 'PhoneIncoming'
  | 'PhoneMissed'
  | 'PhoneOff'
  | 'PhoneOutgoing'
  | 'PieChart'
  | 'Pill'
  | 'Pizza'
  | 'Plane'
  | 'PlaneLanding'
  | 'PlaneTakeoff'
  | 'Play'
  | 'Plus'
  | 'Presentation'
  | 'Printer'
  | 'Puzzle'
  | 'QrCode'
  | 'Radio'
  | 'Receipt'
  | 'Refresh'
  | 'Repeat'
  | 'Rewind'
  | 'Rocket'
  | 'Router'
  | 'Rows'
  | 'Rss'
  | 'Ruler'
  | 'Sailboat'
  | 'Sandwich'
  | 'Save'
  | 'Scan'
  | 'ScanLine'
  | 'School'
  | 'Screwdriver'
  | 'SdCard'
  | 'Search'
  | 'Send'
  | 'Send2'
  | 'Server'
  | 'Settings'
  | 'Share'
  | 'Shield'
  | 'ShieldAlert'
  | 'ShieldCheck'
  | 'ShieldOff'
  | 'Ship'
  | 'ShoppingBag'
  | 'ShoppingCart'
  | 'Shuffle'
  | 'Sidebar'
  | 'Signal'
  | 'SignalHigh'
  | 'SignalLow'
  | 'SignalZero'
  | 'SkipBack'
  | 'SkipForward'
  | 'Smartphone'
  | 'Smile'
  | 'Snowflake'
  | 'Speaker'
  | 'Square'
  | 'Star'
  | 'Stethoscope'
  | 'Store'
  | 'Sun'
  | 'Sunrise'
  | 'Sunset'
  | 'Sword'
  | 'Swords'
  | 'Syringe'
  | 'Table'
  | 'Table2'
  | 'Tablet'
  | 'Tag'
  | 'Tag2'
  | 'Tags'
  | 'Target'
  | 'Tent'
  | 'Terminal'
  | 'TestTube'
  | 'TestTubes'
  | 'Thermometer'
  | 'Thermometer2'
  | 'ThumbsDown'
  | 'ThumbsUp'
  | 'TrafficCone'
  | 'Train'
  | 'Trash'
  | 'Tree'
  | 'TrendingDown'
  | 'TrendingUp'
  | 'Triangle'
  | 'Trophy'
  | 'Truck'
  | 'Tv'
  | 'Umbrella'
  | 'Unlock'
  | 'Upload'
  | 'UsbDrive'
  | 'User'
  | 'UserCheck'
  | 'UserCog'
  | 'UserMinus'
  | 'UserPlus'
  | 'UserX'
  | 'Users'
  | 'Utensils'
  | 'UtensilsCrossed'
  | 'Video'
  | 'Video2'
  | 'VideoOff'
  | 'Voicemail'
  | 'Volume'
  | 'VolumeOff'
  | 'Wallet'
  | 'Wand'
  | 'Wand2'
  | 'Warehouse'
  | 'Watch'
  | 'Waves'
  | 'Webcam'
  | 'Wheelchair'
  | 'Wifi'
  | 'WifiOff'
  | 'Wind'
  | 'Wine'
  | 'Wrench'
  | 'X'
  | 'XCircle'
  | 'Zap';

/**
 * Union type of all available icon names (kebab-case)
 *
 * Useful for configuration objects or CLI tools
 */
export type IconNameKebab =
  | 'accessibility'
  | 'activity'
  | 'airplay'
  | 'alert-circle'
  | 'alert-octagon'
  | 'alert-triangle'
  | 'anchor'
  | 'apple'
  | 'archive'
  | 'area-chart'
  | 'arrow-down'
  | 'arrow-down-left'
  | 'arrow-down-right'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'arrow-up-left'
  | 'arrow-up-right'
  | 'at-sign'
  | 'award'
  | 'baby'
  | 'backpack'
  | 'badge-check'
  | 'ban'
  | 'banana'
  | 'bandage'
  | 'bar-chart'
  | 'bar-chart-2'
  | 'barcode'
  | 'battery'
  | 'battery-charging'
  | 'battery-low'
  | 'beer'
  | 'bell'
  | 'bike'
  | 'bluetooth'
  | 'bone'
  | 'book'
  | 'book-marked'
  | 'book-open'
  | 'bookmark'
  | 'brain'
  | 'brush'
  | 'building'
  | 'building2'
  | 'bus'
  | 'calculator'
  | 'calendar'
  | 'camera'
  | 'car'
  | 'car-front'
  | 'carrot'
  | 'cast'
  | 'castle'
  | 'check'
  | 'check-circle'
  | 'chef-hat'
  | 'cherry'
  | 'chevron-down'
  | 'chevron-up'
  | 'chevrons-down'
  | 'chevrons-left'
  | 'chevrons-right'
  | 'chevrons-up'
  | 'church'
  | 'circle'
  | 'clipboard'
  | 'clipboard-check'
  | 'clipboard-copy'
  | 'clipboard-list'
  | 'clock'
  | 'cloud'
  | 'cloud-drizzle'
  | 'cloud-lightning'
  | 'cloud-rain'
  | 'cloud-snow'
  | 'cloud-sun'
  | 'code'
  | 'code2'
  | 'coffee'
  | 'columns'
  | 'command'
  | 'compass'
  | 'contact'
  | 'contact2'
  | 'cookie'
  | 'copy'
  | 'corner-down-left'
  | 'corner-down-right'
  | 'corner-up-left'
  | 'corner-up-right'
  | 'cpu'
  | 'credit-card'
  | 'crosshair'
  | 'crown'
  | 'cup'
  | 'database'
  | 'dice-1'
  | 'dice-2'
  | 'dice-3'
  | 'dice-4'
  | 'dice-5'
  | 'dice-6'
  | 'dna'
  | 'dollar-sign'
  | 'download'
  | 'droplet'
  | 'dumbbell'
  | 'ear'
  | 'edit'
  | 'eraser'
  | 'eye'
  | 'eye-2'
  | 'eye-off'
  | 'factory'
  | 'fast-forward'
  | 'file'
  | 'file-check'
  | 'file-minus'
  | 'file-plus'
  | 'file-text'
  | 'file-x'
  | 'files'
  | 'film'
  | 'filter'
  | 'fingerprint'
  | 'flame'
  | 'folder'
  | 'folder-minus'
  | 'folder-open'
  | 'folder-plus'
  | 'footprints'
  | 'frown'
  | 'fuel'
  | 'gamepad-2'
  | 'gauge'
  | 'gift'
  | 'glasses'
  | 'globe'
  | 'graduation-cap'
  | 'grape'
  | 'grid'
  | 'hammer'
  | 'hand'
  | 'hard-drive'
  | 'hash'
  | 'headphones'
  | 'heart'
  | 'heart-pulse'
  | 'help-circle'
  | 'highlighter'
  | 'home'
  | 'hospital'
  | 'ice-cream'
  | 'inbox'
  | 'info'
  | 'joystick'
  | 'kanban'
  | 'key'
  | 'key-round'
  | 'keyboard'
  | 'lamp'
  | 'lamp-desk'
  | 'landmark'
  | 'laptop'
  | 'layout'
  | 'layout-grid'
  | 'layout-list'
  | 'leaf'
  | 'library'
  | 'lightbulb'
  | 'lightbulb-off'
  | 'line-chart'
  | 'link'
  | 'list'
  | 'loader'
  | 'lock'
  | 'lock-open'
  | 'mail'
  | 'map'
  | 'map-pin'
  | 'martini'
  | 'maximize'
  | 'maximize-2'
  | 'medal'
  | 'meh'
  | 'menu'
  | 'message-circle'
  | 'message-square'
  | 'mic'
  | 'mic-off'
  | 'microscope'
  | 'milestone'
  | 'minimize'
  | 'minimize-2'
  | 'minus'
  | 'monitor'
  | 'moon'
  | 'more-horizontal'
  | 'mountain'
  | 'mountain-snow'
  | 'mouse'
  | 'move-horizontal'
  | 'music'
  | 'navigation'
  | 'navigation-2'
  | 'notebook'
  | 'notebook-pen'
  | 'package'
  | 'palette'
  | 'panel-left'
  | 'panel-right'
  | 'paperclip'
  | 'parking'
  | 'pause'
  | 'pen'
  | 'pen-tool'
  | 'pencil'
  | 'percent'
  | 'phone'
  | 'phone-call'
  | 'phone-incoming'
  | 'phone-missed'
  | 'phone-off'
  | 'phone-outgoing'
  | 'pie-chart'
  | 'pill'
  | 'pizza'
  | 'plane'
  | 'plane-landing'
  | 'plane-takeoff'
  | 'play'
  | 'plus'
  | 'presentation'
  | 'printer'
  | 'puzzle'
  | 'qr-code'
  | 'radio'
  | 'receipt'
  | 'refresh'
  | 'repeat'
  | 'rewind'
  | 'rocket'
  | 'router'
  | 'rows'
  | 'rss'
  | 'ruler'
  | 'sailboat'
  | 'sandwich'
  | 'save'
  | 'scan'
  | 'scan-line'
  | 'school'
  | 'screwdriver'
  | 'sd-card'
  | 'search'
  | 'send'
  | 'send-2'
  | 'server'
  | 'settings'
  | 'share'
  | 'shield'
  | 'shield-alert'
  | 'shield-check'
  | 'shield-off'
  | 'ship'
  | 'shopping-bag'
  | 'shopping-cart'
  | 'shuffle'
  | 'sidebar'
  | 'signal'
  | 'signal-high'
  | 'signal-low'
  | 'signal-zero'
  | 'skip-back'
  | 'skip-forward'
  | 'smartphone'
  | 'smile'
  | 'snowflake'
  | 'speaker'
  | 'square'
  | 'star'
  | 'stethoscope'
  | 'store'
  | 'sun'
  | 'sunrise'
  | 'sunset'
  | 'sword'
  | 'swords'
  | 'syringe'
  | 'table'
  | 'table-2'
  | 'tablet'
  | 'tag'
  | 'tag2'
  | 'tags'
  | 'target'
  | 'tent'
  | 'terminal'
  | 'test-tube'
  | 'test-tubes'
  | 'thermometer'
  | 'thermometer-2'
  | 'thumbs-down'
  | 'thumbs-up'
  | 'traffic-cone'
  | 'train'
  | 'trash'
  | 'tree'
  | 'trending-down'
  | 'trending-up'
  | 'triangle'
  | 'trophy'
  | 'truck'
  | 'tv'
  | 'umbrella'
  | 'unlock'
  | 'upload'
  | 'usb-drive'
  | 'user'
  | 'user-check'
  | 'user-cog'
  | 'user-minus'
  | 'user-plus'
  | 'user-x'
  | 'users'
  | 'utensils'
  | 'utensils-crossed'
  | 'video'
  | 'video-2'
  | 'video-off'
  | 'voicemail'
  | 'volume'
  | 'volume-off'
  | 'wallet'
  | 'wand'
  | 'wand-2'
  | 'warehouse'
  | 'watch'
  | 'waves'
  | 'webcam'
  | 'wheelchair'
  | 'wifi'
  | 'wifi-off'
  | 'wind'
  | 'wine'
  | 'wrench'
  | 'x'
  | 'x-circle'
  | 'zap';

/**
 * Array of all icon names (PascalCase)
 *
 * @example
 * ```tsx
 * import { ICON_NAMES } from 'motionicon';
 *
 * // Iterate over all icons
 * ICON_NAMES.forEach(name => console.log(name));
 * ```
 */
export const ICON_NAMES = [
  'Accessibility',
  'Activity',
  'Airplay',
  'AlertCircle',
  'AlertOctagon',
  'AlertTriangle',
  'Anchor',
  'Apple',
  'Archive',
  'AreaChart',
  'ArrowDown',
  'ArrowDownLeft',
  'ArrowDownRight',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowUpLeft',
  'ArrowUpRight',
  'AtSign',
  'Award',
  'Baby',
  'Backpack',
  'BadgeCheck',
  'Ban',
  'Banana',
  'Bandage',
  'BarChart',
  'BarChart2',
  'Barcode',
  'Battery',
  'BatteryCharging',
  'BatteryLow',
  'Beer',
  'Bell',
  'Bike',
  'Bluetooth',
  'Bone',
  'Book',
  'BookMarked',
  'BookOpen',
  'Bookmark',
  'Brain',
  'Brush',
  'Building',
  'Building2',
  'Bus',
  'Calculator',
  'Calendar',
  'Camera',
  'Car',
  'CarFront',
  'Carrot',
  'Cast',
  'Castle',
  'Check',
  'CheckCircle',
  'ChefHat',
  'Cherry',
  'ChevronDown',
  'ChevronUp',
  'ChevronsDown',
  'ChevronsLeft',
  'ChevronsRight',
  'ChevronsUp',
  'Church',
  'Circle',
  'Clipboard',
  'ClipboardCheck',
  'ClipboardCopy',
  'ClipboardList',
  'Clock',
  'Cloud',
  'CloudDrizzle',
  'CloudLightning',
  'CloudRain',
  'CloudSnow',
  'CloudSun',
  'Code',
  'Code2',
  'Coffee',
  'Columns',
  'Command',
  'Compass',
  'Contact',
  'Contact2',
  'Cookie',
  'Copy',
  'CornerDownLeft',
  'CornerDownRight',
  'CornerUpLeft',
  'CornerUpRight',
  'Cpu',
  'CreditCard',
  'Crosshair',
  'Crown',
  'Cup',
  'Database',
  'Dice1',
  'Dice2',
  'Dice3',
  'Dice4',
  'Dice5',
  'Dice6',
  'Dna',
  'DollarSign',
  'Download',
  'Droplet',
  'Dumbbell',
  'Ear',
  'Edit',
  'Eraser',
  'Eye',
  'Eye2',
  'EyeOff',
  'Factory',
  'FastForward',
  'File',
  'FileCheck',
  'FileMinus',
  'FilePlus',
  'FileText',
  'FileX',
  'Files',
  'Film',
  'Filter',
  'Fingerprint',
  'Flame',
  'Folder',
  'FolderMinus',
  'FolderOpen',
  'FolderPlus',
  'Footprints',
  'Frown',
  'Fuel',
  'Gamepad2',
  'Gauge',
  'Gift',
  'Glasses',
  'Globe',
  'GraduationCap',
  'Grape',
  'Grid',
  'Hammer',
  'Hand',
  'HardDrive',
  'Hash',
  'Headphones',
  'Heart',
  'HeartPulse',
  'HelpCircle',
  'Highlighter',
  'Home',
  'Hospital',
  'IceCream',
  'Inbox',
  'Info',
  'Joystick',
  'Kanban',
  'Key',
  'KeyRound',
  'Keyboard',
  'Lamp',
  'LampDesk',
  'Landmark',
  'Laptop',
  'Layout',
  'LayoutGrid',
  'LayoutList',
  'Leaf',
  'Library',
  'Lightbulb',
  'LightbulbOff',
  'LineChart',
  'Link',
  'List',
  'Loader',
  'Lock',
  'LockOpen',
  'Mail',
  'Map',
  'MapPin',
  'Martini',
  'Maximize',
  'Maximize2',
  'Medal',
  'Meh',
  'Menu',
  'MessageCircle',
  'MessageSquare',
  'Mic',
  'MicOff',
  'Microscope',
  'Milestone',
  'Minimize',
  'Minimize2',
  'Minus',
  'Monitor',
  'Moon',
  'MoreHorizontal',
  'Mountain',
  'MountainSnow',
  'Mouse',
  'MoveHorizontal',
  'Music',
  'Navigation',
  'Navigation2',
  'Notebook',
  'NotebookPen',
  'Package',
  'Palette',
  'PanelLeft',
  'PanelRight',
  'Paperclip',
  'Parking',
  'Pause',
  'Pen',
  'PenTool',
  'Pencil',
  'Percent',
  'Phone',
  'PhoneCall',
  'PhoneIncoming',
  'PhoneMissed',
  'PhoneOff',
  'PhoneOutgoing',
  'PieChart',
  'Pill',
  'Pizza',
  'Plane',
  'PlaneLanding',
  'PlaneTakeoff',
  'Play',
  'Plus',
  'Presentation',
  'Printer',
  'Puzzle',
  'QrCode',
  'Radio',
  'Receipt',
  'Refresh',
  'Repeat',
  'Rewind',
  'Rocket',
  'Router',
  'Rows',
  'Rss',
  'Ruler',
  'Sailboat',
  'Sandwich',
  'Save',
  'Scan',
  'ScanLine',
  'School',
  'Screwdriver',
  'SdCard',
  'Search',
  'Send',
  'Send2',
  'Server',
  'Settings',
  'Share',
  'Shield',
  'ShieldAlert',
  'ShieldCheck',
  'ShieldOff',
  'Ship',
  'ShoppingBag',
  'ShoppingCart',
  'Shuffle',
  'Sidebar',
  'Signal',
  'SignalHigh',
  'SignalLow',
  'SignalZero',
  'SkipBack',
  'SkipForward',
  'Smartphone',
  'Smile',
  'Snowflake',
  'Speaker',
  'Square',
  'Star',
  'Stethoscope',
  'Store',
  'Sun',
  'Sunrise',
  'Sunset',
  'Sword',
  'Swords',
  'Syringe',
  'Table',
  'Table2',
  'Tablet',
  'Tag',
  'Tag2',
  'Tags',
  'Target',
  'Tent',
  'Terminal',
  'TestTube',
  'TestTubes',
  'Thermometer',
  'Thermometer2',
  'ThumbsDown',
  'ThumbsUp',
  'TrafficCone',
  'Train',
  'Trash',
  'Tree',
  'TrendingDown',
  'TrendingUp',
  'Triangle',
  'Trophy',
  'Truck',
  'Tv',
  'Umbrella',
  'Unlock',
  'Upload',
  'UsbDrive',
  'User',
  'UserCheck',
  'UserCog',
  'UserMinus',
  'UserPlus',
  'UserX',
  'Users',
  'Utensils',
  'UtensilsCrossed',
  'Video',
  'Video2',
  'VideoOff',
  'Voicemail',
  'Volume',
  'VolumeOff',
  'Wallet',
  'Wand',
  'Wand2',
  'Warehouse',
  'Watch',
  'Waves',
  'Webcam',
  'Wheelchair',
  'Wifi',
  'WifiOff',
  'Wind',
  'Wine',
  'Wrench',
  'X',
  'XCircle',
  'Zap',
] as const;

/**
 * Array of all icon names (kebab-case)
 */
export const ICON_NAMES_KEBAB = [
  'accessibility',
  'activity',
  'airplay',
  'alert-circle',
  'alert-octagon',
  'alert-triangle',
  'anchor',
  'apple',
  'archive',
  'area-chart',
  'arrow-down',
  'arrow-down-left',
  'arrow-down-right',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'arrow-up-left',
  'arrow-up-right',
  'at-sign',
  'award',
  'baby',
  'backpack',
  'badge-check',
  'ban',
  'banana',
  'bandage',
  'bar-chart',
  'bar-chart-2',
  'barcode',
  'battery',
  'battery-charging',
  'battery-low',
  'beer',
  'bell',
  'bike',
  'bluetooth',
  'bone',
  'book',
  'book-marked',
  'book-open',
  'bookmark',
  'brain',
  'brush',
  'building',
  'building2',
  'bus',
  'calculator',
  'calendar',
  'camera',
  'car',
  'car-front',
  'carrot',
  'cast',
  'castle',
  'check',
  'check-circle',
  'chef-hat',
  'cherry',
  'chevron-down',
  'chevron-up',
  'chevrons-down',
  'chevrons-left',
  'chevrons-right',
  'chevrons-up',
  'church',
  'circle',
  'clipboard',
  'clipboard-check',
  'clipboard-copy',
  'clipboard-list',
  'clock',
  'cloud',
  'cloud-drizzle',
  'cloud-lightning',
  'cloud-rain',
  'cloud-snow',
  'cloud-sun',
  'code',
  'code2',
  'coffee',
  'columns',
  'command',
  'compass',
  'contact',
  'contact2',
  'cookie',
  'copy',
  'corner-down-left',
  'corner-down-right',
  'corner-up-left',
  'corner-up-right',
  'cpu',
  'credit-card',
  'crosshair',
  'crown',
  'cup',
  'database',
  'dice-1',
  'dice-2',
  'dice-3',
  'dice-4',
  'dice-5',
  'dice-6',
  'dna',
  'dollar-sign',
  'download',
  'droplet',
  'dumbbell',
  'ear',
  'edit',
  'eraser',
  'eye',
  'eye-2',
  'eye-off',
  'factory',
  'fast-forward',
  'file',
  'file-check',
  'file-minus',
  'file-plus',
  'file-text',
  'file-x',
  'files',
  'film',
  'filter',
  'fingerprint',
  'flame',
  'folder',
  'folder-minus',
  'folder-open',
  'folder-plus',
  'footprints',
  'frown',
  'fuel',
  'gamepad-2',
  'gauge',
  'gift',
  'glasses',
  'globe',
  'graduation-cap',
  'grape',
  'grid',
  'hammer',
  'hand',
  'hard-drive',
  'hash',
  'headphones',
  'heart',
  'heart-pulse',
  'help-circle',
  'highlighter',
  'home',
  'hospital',
  'ice-cream',
  'inbox',
  'info',
  'joystick',
  'kanban',
  'key',
  'key-round',
  'keyboard',
  'lamp',
  'lamp-desk',
  'landmark',
  'laptop',
  'layout',
  'layout-grid',
  'layout-list',
  'leaf',
  'library',
  'lightbulb',
  'lightbulb-off',
  'line-chart',
  'link',
  'list',
  'loader',
  'lock',
  'lock-open',
  'mail',
  'map',
  'map-pin',
  'martini',
  'maximize',
  'maximize-2',
  'medal',
  'meh',
  'menu',
  'message-circle',
  'message-square',
  'mic',
  'mic-off',
  'microscope',
  'milestone',
  'minimize',
  'minimize-2',
  'minus',
  'monitor',
  'moon',
  'more-horizontal',
  'mountain',
  'mountain-snow',
  'mouse',
  'move-horizontal',
  'music',
  'navigation',
  'navigation-2',
  'notebook',
  'notebook-pen',
  'package',
  'palette',
  'panel-left',
  'panel-right',
  'paperclip',
  'parking',
  'pause',
  'pen',
  'pen-tool',
  'pencil',
  'percent',
  'phone',
  'phone-call',
  'phone-incoming',
  'phone-missed',
  'phone-off',
  'phone-outgoing',
  'pie-chart',
  'pill',
  'pizza',
  'plane',
  'plane-landing',
  'plane-takeoff',
  'play',
  'plus',
  'presentation',
  'printer',
  'puzzle',
  'qr-code',
  'radio',
  'receipt',
  'refresh',
  'repeat',
  'rewind',
  'rocket',
  'router',
  'rows',
  'rss',
  'ruler',
  'sailboat',
  'sandwich',
  'save',
  'scan',
  'scan-line',
  'school',
  'screwdriver',
  'sd-card',
  'search',
  'send',
  'send-2',
  'server',
  'settings',
  'share',
  'shield',
  'shield-alert',
  'shield-check',
  'shield-off',
  'ship',
  'shopping-bag',
  'shopping-cart',
  'shuffle',
  'sidebar',
  'signal',
  'signal-high',
  'signal-low',
  'signal-zero',
  'skip-back',
  'skip-forward',
  'smartphone',
  'smile',
  'snowflake',
  'speaker',
  'square',
  'star',
  'stethoscope',
  'store',
  'sun',
  'sunrise',
  'sunset',
  'sword',
  'swords',
  'syringe',
  'table',
  'table-2',
  'tablet',
  'tag',
  'tag2',
  'tags',
  'target',
  'tent',
  'terminal',
  'test-tube',
  'test-tubes',
  'thermometer',
  'thermometer-2',
  'thumbs-down',
  'thumbs-up',
  'traffic-cone',
  'train',
  'trash',
  'tree',
  'trending-down',
  'trending-up',
  'triangle',
  'trophy',
  'truck',
  'tv',
  'umbrella',
  'unlock',
  'upload',
  'usb-drive',
  'user',
  'user-check',
  'user-cog',
  'user-minus',
  'user-plus',
  'user-x',
  'users',
  'utensils',
  'utensils-crossed',
  'video',
  'video-2',
  'video-off',
  'voicemail',
  'volume',
  'volume-off',
  'wallet',
  'wand',
  'wand-2',
  'warehouse',
  'watch',
  'waves',
  'webcam',
  'wheelchair',
  'wifi',
  'wifi-off',
  'wind',
  'wine',
  'wrench',
  'x',
  'x-circle',
  'zap',
] as const;

/**
 * Total number of icons in the library
 */
export const ICON_COUNT = 350 as const;

/**
 * Mapping from kebab-case to PascalCase names
 */
export const ICON_NAME_MAP: Record<IconNameKebab, IconName> = {
  'accessibility': 'Accessibility',
  'activity': 'Activity',
  'airplay': 'Airplay',
  'alert-circle': 'AlertCircle',
  'alert-octagon': 'AlertOctagon',
  'alert-triangle': 'AlertTriangle',
  'anchor': 'Anchor',
  'apple': 'Apple',
  'archive': 'Archive',
  'area-chart': 'AreaChart',
  'arrow-down': 'ArrowDown',
  'arrow-down-left': 'ArrowDownLeft',
  'arrow-down-right': 'ArrowDownRight',
  'arrow-left': 'ArrowLeft',
  'arrow-right': 'ArrowRight',
  'arrow-up': 'ArrowUp',
  'arrow-up-left': 'ArrowUpLeft',
  'arrow-up-right': 'ArrowUpRight',
  'at-sign': 'AtSign',
  'award': 'Award',
  'baby': 'Baby',
  'backpack': 'Backpack',
  'badge-check': 'BadgeCheck',
  'ban': 'Ban',
  'banana': 'Banana',
  'bandage': 'Bandage',
  'bar-chart': 'BarChart',
  'bar-chart-2': 'BarChart2',
  'barcode': 'Barcode',
  'battery': 'Battery',
  'battery-charging': 'BatteryCharging',
  'battery-low': 'BatteryLow',
  'beer': 'Beer',
  'bell': 'Bell',
  'bike': 'Bike',
  'bluetooth': 'Bluetooth',
  'bone': 'Bone',
  'book': 'Book',
  'book-marked': 'BookMarked',
  'book-open': 'BookOpen',
  'bookmark': 'Bookmark',
  'brain': 'Brain',
  'brush': 'Brush',
  'building': 'Building',
  'building2': 'Building2',
  'bus': 'Bus',
  'calculator': 'Calculator',
  'calendar': 'Calendar',
  'camera': 'Camera',
  'car': 'Car',
  'car-front': 'CarFront',
  'carrot': 'Carrot',
  'cast': 'Cast',
  'castle': 'Castle',
  'check': 'Check',
  'check-circle': 'CheckCircle',
  'chef-hat': 'ChefHat',
  'cherry': 'Cherry',
  'chevron-down': 'ChevronDown',
  'chevron-up': 'ChevronUp',
  'chevrons-down': 'ChevronsDown',
  'chevrons-left': 'ChevronsLeft',
  'chevrons-right': 'ChevronsRight',
  'chevrons-up': 'ChevronsUp',
  'church': 'Church',
  'circle': 'Circle',
  'clipboard': 'Clipboard',
  'clipboard-check': 'ClipboardCheck',
  'clipboard-copy': 'ClipboardCopy',
  'clipboard-list': 'ClipboardList',
  'clock': 'Clock',
  'cloud': 'Cloud',
  'cloud-drizzle': 'CloudDrizzle',
  'cloud-lightning': 'CloudLightning',
  'cloud-rain': 'CloudRain',
  'cloud-snow': 'CloudSnow',
  'cloud-sun': 'CloudSun',
  'code': 'Code',
  'code2': 'Code2',
  'coffee': 'Coffee',
  'columns': 'Columns',
  'command': 'Command',
  'compass': 'Compass',
  'contact': 'Contact',
  'contact2': 'Contact2',
  'cookie': 'Cookie',
  'copy': 'Copy',
  'corner-down-left': 'CornerDownLeft',
  'corner-down-right': 'CornerDownRight',
  'corner-up-left': 'CornerUpLeft',
  'corner-up-right': 'CornerUpRight',
  'cpu': 'Cpu',
  'credit-card': 'CreditCard',
  'crosshair': 'Crosshair',
  'crown': 'Crown',
  'cup': 'Cup',
  'database': 'Database',
  'dice-1': 'Dice1',
  'dice-2': 'Dice2',
  'dice-3': 'Dice3',
  'dice-4': 'Dice4',
  'dice-5': 'Dice5',
  'dice-6': 'Dice6',
  'dna': 'Dna',
  'dollar-sign': 'DollarSign',
  'download': 'Download',
  'droplet': 'Droplet',
  'dumbbell': 'Dumbbell',
  'ear': 'Ear',
  'edit': 'Edit',
  'eraser': 'Eraser',
  'eye': 'Eye',
  'eye-2': 'Eye2',
  'eye-off': 'EyeOff',
  'factory': 'Factory',
  'fast-forward': 'FastForward',
  'file': 'File',
  'file-check': 'FileCheck',
  'file-minus': 'FileMinus',
  'file-plus': 'FilePlus',
  'file-text': 'FileText',
  'file-x': 'FileX',
  'files': 'Files',
  'film': 'Film',
  'filter': 'Filter',
  'fingerprint': 'Fingerprint',
  'flame': 'Flame',
  'folder': 'Folder',
  'folder-minus': 'FolderMinus',
  'folder-open': 'FolderOpen',
  'folder-plus': 'FolderPlus',
  'footprints': 'Footprints',
  'frown': 'Frown',
  'fuel': 'Fuel',
  'gamepad-2': 'Gamepad2',
  'gauge': 'Gauge',
  'gift': 'Gift',
  'glasses': 'Glasses',
  'globe': 'Globe',
  'graduation-cap': 'GraduationCap',
  'grape': 'Grape',
  'grid': 'Grid',
  'hammer': 'Hammer',
  'hand': 'Hand',
  'hard-drive': 'HardDrive',
  'hash': 'Hash',
  'headphones': 'Headphones',
  'heart': 'Heart',
  'heart-pulse': 'HeartPulse',
  'help-circle': 'HelpCircle',
  'highlighter': 'Highlighter',
  'home': 'Home',
  'hospital': 'Hospital',
  'ice-cream': 'IceCream',
  'inbox': 'Inbox',
  'info': 'Info',
  'joystick': 'Joystick',
  'kanban': 'Kanban',
  'key': 'Key',
  'key-round': 'KeyRound',
  'keyboard': 'Keyboard',
  'lamp': 'Lamp',
  'lamp-desk': 'LampDesk',
  'landmark': 'Landmark',
  'laptop': 'Laptop',
  'layout': 'Layout',
  'layout-grid': 'LayoutGrid',
  'layout-list': 'LayoutList',
  'leaf': 'Leaf',
  'library': 'Library',
  'lightbulb': 'Lightbulb',
  'lightbulb-off': 'LightbulbOff',
  'line-chart': 'LineChart',
  'link': 'Link',
  'list': 'List',
  'loader': 'Loader',
  'lock': 'Lock',
  'lock-open': 'LockOpen',
  'mail': 'Mail',
  'map': 'Map',
  'map-pin': 'MapPin',
  'martini': 'Martini',
  'maximize': 'Maximize',
  'maximize-2': 'Maximize2',
  'medal': 'Medal',
  'meh': 'Meh',
  'menu': 'Menu',
  'message-circle': 'MessageCircle',
  'message-square': 'MessageSquare',
  'mic': 'Mic',
  'mic-off': 'MicOff',
  'microscope': 'Microscope',
  'milestone': 'Milestone',
  'minimize': 'Minimize',
  'minimize-2': 'Minimize2',
  'minus': 'Minus',
  'monitor': 'Monitor',
  'moon': 'Moon',
  'more-horizontal': 'MoreHorizontal',
  'mountain': 'Mountain',
  'mountain-snow': 'MountainSnow',
  'mouse': 'Mouse',
  'move-horizontal': 'MoveHorizontal',
  'music': 'Music',
  'navigation': 'Navigation',
  'navigation-2': 'Navigation2',
  'notebook': 'Notebook',
  'notebook-pen': 'NotebookPen',
  'package': 'Package',
  'palette': 'Palette',
  'panel-left': 'PanelLeft',
  'panel-right': 'PanelRight',
  'paperclip': 'Paperclip',
  'parking': 'Parking',
  'pause': 'Pause',
  'pen': 'Pen',
  'pen-tool': 'PenTool',
  'pencil': 'Pencil',
  'percent': 'Percent',
  'phone': 'Phone',
  'phone-call': 'PhoneCall',
  'phone-incoming': 'PhoneIncoming',
  'phone-missed': 'PhoneMissed',
  'phone-off': 'PhoneOff',
  'phone-outgoing': 'PhoneOutgoing',
  'pie-chart': 'PieChart',
  'pill': 'Pill',
  'pizza': 'Pizza',
  'plane': 'Plane',
  'plane-landing': 'PlaneLanding',
  'plane-takeoff': 'PlaneTakeoff',
  'play': 'Play',
  'plus': 'Plus',
  'presentation': 'Presentation',
  'printer': 'Printer',
  'puzzle': 'Puzzle',
  'qr-code': 'QrCode',
  'radio': 'Radio',
  'receipt': 'Receipt',
  'refresh': 'Refresh',
  'repeat': 'Repeat',
  'rewind': 'Rewind',
  'rocket': 'Rocket',
  'router': 'Router',
  'rows': 'Rows',
  'rss': 'Rss',
  'ruler': 'Ruler',
  'sailboat': 'Sailboat',
  'sandwich': 'Sandwich',
  'save': 'Save',
  'scan': 'Scan',
  'scan-line': 'ScanLine',
  'school': 'School',
  'screwdriver': 'Screwdriver',
  'sd-card': 'SdCard',
  'search': 'Search',
  'send': 'Send',
  'send-2': 'Send2',
  'server': 'Server',
  'settings': 'Settings',
  'share': 'Share',
  'shield': 'Shield',
  'shield-alert': 'ShieldAlert',
  'shield-check': 'ShieldCheck',
  'shield-off': 'ShieldOff',
  'ship': 'Ship',
  'shopping-bag': 'ShoppingBag',
  'shopping-cart': 'ShoppingCart',
  'shuffle': 'Shuffle',
  'sidebar': 'Sidebar',
  'signal': 'Signal',
  'signal-high': 'SignalHigh',
  'signal-low': 'SignalLow',
  'signal-zero': 'SignalZero',
  'skip-back': 'SkipBack',
  'skip-forward': 'SkipForward',
  'smartphone': 'Smartphone',
  'smile': 'Smile',
  'snowflake': 'Snowflake',
  'speaker': 'Speaker',
  'square': 'Square',
  'star': 'Star',
  'stethoscope': 'Stethoscope',
  'store': 'Store',
  'sun': 'Sun',
  'sunrise': 'Sunrise',
  'sunset': 'Sunset',
  'sword': 'Sword',
  'swords': 'Swords',
  'syringe': 'Syringe',
  'table': 'Table',
  'table-2': 'Table2',
  'tablet': 'Tablet',
  'tag': 'Tag',
  'tag2': 'Tag2',
  'tags': 'Tags',
  'target': 'Target',
  'tent': 'Tent',
  'terminal': 'Terminal',
  'test-tube': 'TestTube',
  'test-tubes': 'TestTubes',
  'thermometer': 'Thermometer',
  'thermometer-2': 'Thermometer2',
  'thumbs-down': 'ThumbsDown',
  'thumbs-up': 'ThumbsUp',
  'traffic-cone': 'TrafficCone',
  'train': 'Train',
  'trash': 'Trash',
  'tree': 'Tree',
  'trending-down': 'TrendingDown',
  'trending-up': 'TrendingUp',
  'triangle': 'Triangle',
  'trophy': 'Trophy',
  'truck': 'Truck',
  'tv': 'Tv',
  'umbrella': 'Umbrella',
  'unlock': 'Unlock',
  'upload': 'Upload',
  'usb-drive': 'UsbDrive',
  'user': 'User',
  'user-check': 'UserCheck',
  'user-cog': 'UserCog',
  'user-minus': 'UserMinus',
  'user-plus': 'UserPlus',
  'user-x': 'UserX',
  'users': 'Users',
  'utensils': 'Utensils',
  'utensils-crossed': 'UtensilsCrossed',
  'video': 'Video',
  'video-2': 'Video2',
  'video-off': 'VideoOff',
  'voicemail': 'Voicemail',
  'volume': 'Volume',
  'volume-off': 'VolumeOff',
  'wallet': 'Wallet',
  'wand': 'Wand',
  'wand-2': 'Wand2',
  'warehouse': 'Warehouse',
  'watch': 'Watch',
  'waves': 'Waves',
  'webcam': 'Webcam',
  'wheelchair': 'Wheelchair',
  'wifi': 'Wifi',
  'wifi-off': 'WifiOff',
  'wind': 'Wind',
  'wine': 'Wine',
  'wrench': 'Wrench',
  'x': 'X',
  'x-circle': 'XCircle',
  'zap': 'Zap',
};

/**
 * Type guard to check if a string is a valid icon name
 */
export function isIconName(name: string): name is IconName {
  return ICON_NAMES.includes(name as IconName);
}

/**
 * Type guard to check if a string is a valid kebab-case icon name
 */
export function isIconNameKebab(name: string): name is IconNameKebab {
  return ICON_NAMES_KEBAB.includes(name as IconNameKebab);
}
